import { Button, Divider, Space, notification } from "antd";
import { CallbackInfo, DefaultDisplayDateFormat, HourOnlyFormat } from "data/CustomerPortalTypes";
import { useSelector } from "react-redux";
import { disconnectCallback } from "services/RequestDataService";
import { selectCurrentAccount } from "store/userSlice";
import '../Callback.css';
import moment from "moment";
import { startSpinner, stopSpinner } from "utilities/Utility";
import trackEvent from "services/AnalyticsService";

const buildTimeSlotString = (scheduledDateTime : moment.Moment | Date) => {
    const timeSlotStart = moment(scheduledDateTime).format(`${DefaultDisplayDateFormat} (${HourOnlyFormat}`);
    const timeSlotEnd = moment(scheduledDateTime).add(1, 'hour').format(`${HourOnlyFormat})`);

    return `${timeSlotStart} - ${timeSlotEnd}`;
}

const ExistingCallback = ({
    existingCallbackInfoList,
    refreshCallbackInfo,
    publicHolidays
} : {
    existingCallbackInfoList: CallbackInfo[],
    refreshCallbackInfo: () => void,
    publicHolidays: string[]
}) => {

    const currentAccount = useSelector(selectCurrentAccount);

    const ignoreCallbackRequest = async (callerPhoneNumber: string, conversationId: string) => {
        if (!currentAccount) {
            return;
        }

        var response = await disconnectCallback(currentAccount.accountId, callerPhoneNumber, conversationId);

        const { success, data } = response || {};
        
        if (success && data) {
            notification.success({
                message: 'Callback request deleted',
                description: 'The callback request has been deleted successfully.'
            });
            
            trackEvent("click", "callback", "ignore_callback", currentAccount.accountId);

            startSpinner();
            await new Promise(resolve => setTimeout(resolve, 1500));
            stopSpinner();
            refreshCallbackInfo();
        }
    };

    if (!currentAccount || !existingCallbackInfoList) {
        return null;
    }

    return (
        <div className="callback-form">
            <h2>You have existing callback request(s)</h2>
            {existingCallbackInfoList.map((existingCallbackInfo, index) =>
                <>
                    <Divider style={{ margin: '15px 0' }} />
                    <p style={{ marginTop: '15px' }}><b>Phone Number:</b> {existingCallbackInfo.callerPhoneNumber}</p>
                    <p><b>Category:</b> {existingCallbackInfo.callbackType}</p>
                    <>
                        {existingCallbackInfo.scheduleUtcDateTime
                            ? <>
                                <p><b>Scheduled Time:</b> {buildTimeSlotString(existingCallbackInfo.scheduleUtcDateTime)}</p>
                                <p style={{ marginTop: '10px' }}>We'll do our best to contact you around the requested time slot, however, we cannot always guarantee it will happen at the requested time.</p>
                            </>
                            : null}
                        <Space wrap style={{ marginTop: '10px' }}>
                            <Button
                                onClick={() => ignoreCallbackRequest(existingCallbackInfo.callerPhoneNumber, existingCallbackInfo.conversationId)}
                                type="default"
                                htmlType="submit"
                                size="middle"
                                id={"cancelCallbackRequestBtn"}
                                disabled={false}>
                                Cancel Callback Request
                            </Button>
                        </Space>
                    </>
                </>)}
        </div>
    );
};

export default ExistingCallback;